import { LatLng } from '../types/latlng';
import { BaseDto } from './base-dto';

export class CheckProviderShop extends BaseDto<CheckProviderShop> {
    public orderID: number;
    public position: LatLng;
}
